var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/analytics"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m21 3-1.855 1.679M6 18l1.85-5.06M3 3v15a3 3 0 0 0 3 3h15m-8.302-6.421L9.28 12.465m8.42-5.793-3.18 7.176M19.5 5.55a1.25 1.25 0 1 1-2.499 0 1.25 1.25 0 0 1 2.499 0Zm-4.354 9.38a1.25 1.25 0 1 1-2.498 0 1.25 1.25 0 0 1 2.498 0Zm-5.644-3.174a1.25 1.25 0 1 1-2.499 0 1.25 1.25 0 0 1 2.499 0Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.cb957e511ff2c39e2cfebdaa0b4f24be.svg";
export { ForwardRef as ReactComponent };